<template>
  <ion-page>
    <ion-content :fullscreen="true">
      <ion-card style="box-shadow: none; display: flex; flex-direction: column; justify-content: space-between">
        <div>
          <ion-card-header>
            <PageNavigation page-precedente="activitee3" page-suivante="activitee5" :page-title="pageTitle" :show-left-arrow="true" :show-right-arrow="false"/>
            <!--<ion-card-subtitle>Parcours une nouvelle fois la liste des métiers et des formations et
              inscris ceux que tu aimerais découvrir lors de ta visite dans ta liste de favoris !</ion-card-subtitle>-->
          </ion-card-header>
          <ion-card-content>
            <ListeFavoris
                v-if="getMetiersFavoris.length"
                :metiers="getMetiersFavoris"
            />
            <div class="vide" v-else>
              <div class="content">
                <h2>Pas encore de favoris ?</h2>
                <p>Parcours les métiers et tague ceux qui t'intéressent.</p>
              </div>
            </div>
            <ion-button expand="block" fill="solid" @click="this.$router.push('/tabs/metiers')">Aller voir les métiers</ion-button>
          </ion-card-content>
        </div>
      </ion-card>
    </ion-content>
  </ion-page>
</template>

<script>

import {defineComponent, ref } from "vue";
import {
  IonButton,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonContent,
  IonPage
} from "@ionic/vue";
import ListeFavoris from "@/components/ListeFavoris.vue";
import {mapGetters} from "vuex";
import PageNavigation from "@/components/PageNavigation.vue";

export default defineComponent({
  components: {
    PageNavigation,
    ListeFavoris,
    IonContent,
    IonButton,
    IonCard,
    IonPage,
    IonCardHeader,
    IonCardContent
  },
  computed: {
    ...mapGetters(['getMetiersFavoris'])
  },
  data() {
    return {
      pageTitle: '4/4 Les stands à ne pas manquer',
    }
  },
  setup() {
    const showToast = ref(false);

    const dismissToast = () => {
      showToast.value = false;
    };

    const showTheToast = () => {
      console.log('test');
      showToast.value = true;
    };

    return { showToast, dismissToast, showTheToast };
  },
})
</script>

<style scoped>
ion-card {
  box-sizing: border-box;
  margin: 0;
}

ion-card-header {
  margin-top: 80px;
}

ion-select {
  display: inline-flex;
  width: 40%;
  border-bottom: solid 2px #e30613;
  height: 20px;
}

ion-textarea {
  height: 30%;
  border: solid 2px #e30613;
  border-radius: 5px;
  padding: 0.5em;
}

ion-card-content {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}

.vide .content {
  padding: 20px;
}
</style>
